import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

const HubertCard = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('bg-card text-card-foreground rounded-xl border border-gray-200 shadow', className)}
    {...props}
  />
));
HubertCard.displayName = 'HubertCard';

const HubertCardHeader = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
  ),
);
HubertCardHeader.displayName = 'HubertCardHeader';

const HubertCardTitle = forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3 ref={ref} className={cn('leading-none font-semibold tracking-tight', className)} {...props} />
  ),
);
HubertCardTitle.displayName = 'HubertCardTitle';

const HubertCardDescription = forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cn('text-muted-foreground text-sm', className)} {...props} />
  ),
);
HubertCardDescription.displayName = 'HubertCardDescription';

const HubertCardContent = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />,
);

HubertCardContent.displayName = 'HubertCardContent';

const HubertCardFooter = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />
  ),
);
HubertCardFooter.displayName = 'HubertCardFooter';

export { HubertCard };
